import {useContext} from "react";
import {ThatsMeBabyContext} from "../../common/contexts/thatsMeBabyContext";
import {ThatsMeLoadingButton} from "./thatsMeLoadingButton";
import {Copy} from "@carbon/icons-react";
import {Typography} from "@mui/material";
import {EnvironmentConfig} from "../../common/configs/environment.config";

const ShareableLink = () => {
    
    const {profile} = useContext(ThatsMeBabyContext);

    const userCustomURL = `${EnvironmentConfig.BaseUrl}/${profile?.customUrlPathName}`;
    
    return (
        <ThatsMeLoadingButton 
            fullWidth 
            onClick={() => navigator.clipboard.writeText(userCustomURL)} 
            variant={"shareLink"} 
        > 
            <Typography variant={"body1"} width={"calc(100% - 32px)"} overflow={"hidden"} textOverflow={"ellipsis"} >{userCustomURL}</Typography> 
            <Copy size={24} style={{position: "absolute", right: "16px"}} /> 
        </ThatsMeLoadingButton>
    );
}

export default ShareableLink